import type { CountryTld } from '@features/cities/types'

export const DOMAIN_COUNTRY = {
  ru: 'Россия',
  kg: 'Кыргызстан',
  com: 'Казахстан',
} satisfies Record<CountryTld, string>

export const DEFAULT_COUNTRY_TLD: CountryTld = 'ru'
